module.exports = __webpack_public_path__ + "media/img/payment-methods/hipercard-006f8db14eb025041040349b1ae8303b.svg";